const Template = `<div class="cart">
    <ul class="nav nav-tabs">
        <li class="nav-item fs-7">
            <a class="nav-link active custom-link" href="#cart" data-bs-toggle="tab">
                سبد خرید
            </a>
        </li>
    </ul>
    <div class="tab-content p-3">
        <div class="tab-pane fade show active text-center" id="cart">
            <div class="cart-empty border border-radius-3xl py-5">
                <img src="/static/images/empty-cart.svg" alt="" />
                <p class="fs-5 fw-bold mt-3">سبد خرید شما خالی است!</p>
            </div>
        </div>
    </div>
</div>`

export default Template;